import React, { useState } from 'react';
import { TooltipIcon } from '..';
import { Colors } from '../../../constants/Colors';
import { dotColor, getStatusInfo, isStatus } from '../../../utils/Utils';
import {
  StyledTable,
  StyledHead,
  StyledTableBody,
  StyledTH,
  StyledTR,
  StyledTD,
  StyledContent,
  StyledStatusDot
} from './Styles';

export default function Table(props) {
  const { data, headers } = props;

  const rows = data?.map(row => (
    <Table.TR>
      {Object.entries(row)
        .filter(([key, value]) => key !== 'is_coparticipation')
        .map(([key, value]) => (
          <Table.TD rowContent={row}>{value}</Table.TD>
        ))}
    </Table.TR>
  ));

  return (
    <StyledTable {...props}>
      <StyledHead>
        <Table.TR>
          {headers.map(head => (
            <Table.TH>{head}</Table.TH>
          ))}
        </Table.TR>
      </StyledHead>
      <StyledTableBody>{rows}</StyledTableBody>
    </StyledTable>
  );
}

Table.TH = props => <StyledTH {...props} />;

Table.TR = props => <StyledTR {...props} />;

Table.TD = props => {
  const { children: item, rowContent } = props;

  const checkIsStatus = item => isStatus(item);

  const handleStatus = item => {
    const getDotColor = item => dotColor(item);

    if (checkIsStatus(item)) {
      return (
        <TooltipIcon placement="left" icon={'mdi mdi-help-circle'} title={getStatusInfo(item)} />
      );
    }

    return false;
  };

  return (
    <StyledTD {...props}>
      <StyledContent isStatus={checkIsStatus(item)}>
        {item}
        {handleStatus(item)}
      </StyledContent>
    </StyledTD>
  );
};
